/*
 * @Author: syc
 * @Date: 2023-03-15 23:50:51
 * @LastEditors: syc
 * @LastEditTime: 2023-03-22 17:34:09
 * @FilePath: \yfy-mp\src\utils\rem.js
 * @Description: rem.js
 * Copyright (c) 2023 by song, All Rights Reserved.
 */
// rem等比适配配置文件
// 基准大小
const baseSize = 16
// 设置 rem 函数
function setRem() {
  // 当前页面屏幕分辨率相对于 390 宽的缩放比例，可根据自己需要修改
  const scale = document.documentElement.clientWidth / 390
  // 设置页面根节点字体大小（“Math.min(scale, 1.2)” 指最高放大比例为1.2，可根据实际业务需求调整）
  document.documentElement.style.fontSize =
    baseSize * Math.min(scale, 1.2) + 'px'
}
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem()
}
